import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Header, Dropdown } from 'semantic-ui-react';
import { getOtherCategoryNames } from './CategoryHeader.utils';
import MarkdownField from '../../../../../../../components/MarkdownContent';
import PageAnchor from '../../../../../../../components/PageAnchor';
import { MenuCategoryPropType } from '../../../../../../../services/proptypes';
import { MenuConsumer } from '../../../../../FoodMenu.context';
import './CategoryHeader.css';
var defaultProps = {
  scheduleCategories: []
};
var CategoryHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(CategoryHeader, _React$Component);
  var _super = _createSuper(CategoryHeader);
  function CategoryHeader(props) {
    var _this;
    _classCallCheck(this, CategoryHeader);
    _this = _super.call(this, props);
    _this.state = {
      active: false
    };
    return _this;
  }
  _createClass(CategoryHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        category = _this$props.category,
        scheduleCategories = _this$props.scheduleCategories;
      var active = this.state.active;
      return /*#__PURE__*/React.createElement(MenuConsumer, null, function (_ref) {
        var showCategoryDropdown = _ref.showCategoryDropdown;
        var name = category.name,
          description = category.description;
        var options = getOtherCategoryNames(scheduleCategories, name);

        // only display navigation if 2 or more options available
        var displayCategoryDropdown = showCategoryDropdown && options.length >= 2;
        return /*#__PURE__*/React.createElement("div", {
          className: "menu-category-header-wrapper"
        }, /*#__PURE__*/React.createElement(Header, {
          as: "h2",
          icon: true,
          className: "menu-category-header ".concat(active && 'active')
        }, displayCategoryDropdown ? /*#__PURE__*/React.createElement(Dropdown, {
          text: name,
          onOpen: function onOpen() {
            _this2.setState({
              active: true
            });
          },
          onClose: function onClose() {
            _this2.setState({
              active: false
            });
          }
        }, /*#__PURE__*/React.createElement(Dropdown.Menu, null, options.map(function (option) {
          return /*#__PURE__*/React.createElement(PageAnchor, {
            componentId: option
          }, function (_ref2) {
            var onClick = _ref2.onClick;
            return /*#__PURE__*/React.createElement(Dropdown.Item, {
              className: "dropdown-item-anchor",
              key: option,
              onClick: onClick
            }, option);
          });
        }))) : name), /*#__PURE__*/React.createElement(MarkdownField, {
          className: "sub header",
          style: {
            marginTop: '10px'
          }
        }, description));
      });
    }
  }]);
  return CategoryHeader;
}(React.Component);
export { CategoryHeader as default };
CategoryHeader.defaultProps = defaultProps;